export default __webpack_public_path__ + "static/media/esther.63b1e689.jpg";